const POPULAR = [
  ["diabetes", "fa-droplet", "Diabetes & blood sugar"],
  ["heart", "fa-heart-pulse", "Heart & blood pressure"],
  ["immunity", "fa-shield-virus", "Immunity & detox"],
  ["mens", "fa-mars", "Men's health & fertility"],
  ["weight", "fa-weight-scale", "Weight management"],
];

export default function Hero({ onConcern }) {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div>
          <span className="eyebrow" style={{ color: "var(--gold-soft)" }}>
            Natural Supplements for a Healthy Living
          </span>
          <h1>
            Nature's pride for your <em>health &amp; vitality</em>.
          </h1>
          <p className="lead">
            Curious about a health concern like diabetes, blood pressure or low energy? Explore it here — learn what
            helps, then discover the natural products and care packages tailored to you.
          </p>
          <div className="hero-cta">
            <a href="#concerns" className="btn btn-gold">
              <i className="fa-solid fa-magnifying-glass" /> Explore by concern
            </a>
            <a href="#products" className="btn btn-ghost">
              <i className="fa-solid fa-leaf" /> Shop products
            </a>
          </div>
          <div className="hero-stats">
            <div>
              <b>50+</b>
              <span>Natural products</span>
            </div>
            <div>
              <b>14</b>
              <span>Care packages</span>
            </div>
            <div>
              <b>100%</b>
              <span>Herbal-based</span>
            </div>
          </div>
        </div>
        <div className="hero-card">
          <h3>Popular concerns</h3>
          {POPULAR.map(([id, icon, label]) => (
            <div className="pill" key={id} onClick={() => onConcern(id)}>
              <i className={`fa-solid ${icon}`} /> {label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
